import React from 'react';
import classNames from 'classnames';
import styles from './ClickableDescriptionSettings.module.scss';

interface ClickableDescriptionSettingsProps {
  prefix: string;
  linkText: string;
  suffix?: string;
  linkUrl: string;
  className?: string;
}

export function ClickableDescriptionSettings(props: ClickableDescriptionSettingsProps) {
  const { prefix, linkText, suffix, linkUrl, className } = props;

  return (
    <div className={classNames(styles.container, className)}>
      <span>{prefix}</span>
      <a className={styles.link} href={linkUrl} target="_blank" rel="noopener noreferrer">
        {linkText}
      </a>
      {suffix && <span>{suffix}</span>}
    </div>
  );
}
